(function ($) {
    // Minimum file size adapter
    $.validator.unobtrusive.adapters.add('minimumfilesize', ['minimumbytes'], function (options) {
        // Set up test parameters
        var params = {
            minimumBytes: options.params.minimumbytes
        };

        // Match parameters to the method to execute
        options.rules['minimumfilesize'] = params;
        if (options.message) {
            // If there is a message, set it for the rule
            options.messages['minimumfilesize'] = options.message;
        }
    });

    // Minimum file size method
    $.validator.addMethod("minimumfilesize", function (value, element, params) {
        if (value === "") {
            // no file supplied
            return true;
        }

        var minimumBytes = parseInt(params.minimumBytes);

        // HTML 5 API required
        if (element.files !== undefined && element.files[0] !== undefined && element.files[0].size !== undefined) {
            var filesize = parseInt(element.files[0].size);

            if (filesize < minimumBytes)
                return false;
            else
                return true;
        }

        // Only get here if the HTML 5 API is not supported, in which case just allow the file through to get server validated
        return true;
    });


    // Maximum file size adapter
    $.validator.unobtrusive.adapters.add('maximumfilesize', ['maximumbytes'], function (options) {
        // Set up test parameters
        var params = {
            maximumBytes: options.params.maximumbytes
        };

        // Match parameters to the method to execute
        options.rules['maximumfilesize'] = params;
        if (options.message) {
            // If there is a message, set it for the rule
            options.messages['maximumfilesize'] = options.message;
        }
    });

    // Maximum file size method
    $.validator.addMethod("maximumfilesize", function (value, element, params) {
        if (value === "") {
            // no file supplied
            return true;
        }

        var maximumBytes = parseInt(params.maximumBytes);

        // HTML 5 API required
        if (element.files !== undefined && element.files[0] !== undefined && element.files[0].size !== undefined) {
            var filesize = parseInt(element.files[0].size);

            if (filesize > maximumBytes)
                return false;
            else
                return true;
        }

        // Only get here if the HTML 5 API is not supported, in which case just allow the file through to get server validated
        return true;
    });

    // Valid file extension adapter
    $.validator.unobtrusive.adapters.add('validfileextensions', ['validextensions'], function (options) {
        // Set up test parameters
        var params = {
            validExtensions: options.params.validextensions
        };

        // Match parameters to the method to execute
        options.rules['validfileextensions'] = params;
        if (options.message) {
            // If there is a message, set it for the rule
            options.messages['validfileextensions'] = options.message;
        }
    });

    // Valid file extension method
    $.validator.addMethod("validfileextensions", function (value, element, params) {
        if (value === "") {
            // no file supplied
            return true;
        }

        // Get the valid extension list
        var validExtensions = params.validExtensions;

        // Uppercase the extensions to make comparisons case-insensitive
        validExtensions = validExtensions.toUpperCase();
        
        // Convert the list to an array
        if (validExtensions.indexOf(', ') > -1) {
            validExtensions = validExtensions.split(', ');
        } else {
            validExtensions = [validExtensions];
        }

        // Get the current file
        var currentFileName = getFileName(value);

        // Get the extension of the current file
        var currentExtension = getExtension(value);

        // If the extension is found in the array, then it's valid
        if (validExtensions.indexOf(currentExtension.toUpperCase()) > -1) {
            return true;
        }

        // Only get here if the extension was not found
        return false;
    });

    // Compare strings adapters (with case-insensitive capabilities)
    $.validator.unobtrusive.adapters.add("expectedvalue", ["valueexpected", "ignorecase"], function (options) {
        options.rules["expectedvalue"] = {
            valueExpected: options.params.valueexpected,
            ignoreCase: options.params.ignorecase === "true"
        };
        options.messages["expectedvalue"] = options.message;
    });

    // Compare strings method (with case-insensitive capabilities)
    $.validator.addMethod("expectedvalue", function (value, element, params) {
        var valueExpected = params.valueExpected;
        var ignoreCase = params.ignoreCase;

        value = $.trim(value);

        // Check if the value matches the value expected
        if (!ignoreCase && value === valueExpected)
            return true;
        else if (ignoreCase && value.toUpperCase() === valueExpected.toUpperCase())
            return true;
        else
            return false;
    });

    // Compare strings adapters (with case-insensitive capabilities)
    $.validator.unobtrusive.adapters.add("comparestrings", ["otherprop", "ignorecase"], function (options) {
        options.rules["comparestrings"] = {
            otherPropName: options.params.otherprop,
            ignoreCase: options.params.ignorecase === "true"
        };
        options.messages["comparestrings"] = options.message;
    });

    // Compare strings method (with case-insensitive capabilities)
    $.validator.addMethod("comparestrings", function (value, element, params) {
        // Get the MVC-generated prefix of element
        // (E.G. "MyViewModel_" from id="MyViewModel_CompareEmail"
        var modelPrefix = getModelIDPrefix($(element).prop("id"));

        // otherPropName is the name of the property but not the actual element
        // Concatenate element's modelPrefix with the otherPropName to get the full MVC-generated ID.
        var $otherPropElem = $("#" + modelPrefix + params.otherPropName);

        var otherPropValue = getElemValue($otherPropElem);

        // Note: Logic for comparing strings needs to match what it does on the server side

        // Trim values
        value = $.trim(value);
        otherPropValue = $.trim(otherPropValue);

        // If ignoring case, lower both values
        if (params.ignoreCase) {
            value = value.toUpperCase();
            otherPropValue = otherPropValue.toUpperCase();
        }

        // Compare the values
        var isMatch = value === otherPropValue;

        return isMatch;
    });

    // Get the file name from a full path, which works with both slash directions
    function getFileName(path) {
        return path.split(/[\\/]/).pop();
    }

    // Gets the extension from the passed in path
    function getExtension(path) {
        var basename = getFileName(path);

        // Get last position of . character
        var pos = basename.lastIndexOf(".");

        // If the filename is empty, then return no extension
        if (basename === "")
            return "";

        // Return the extension with the . character
        return basename.slice(pos);
    }

    // Get the value of any element, regardless of the type of element
    function getElemValue(element) {
        var value;
        var $elem = $(element);

        // Checkboxes and radio buttons are true/false values
        if ($elem.is(":checkbox") || $elem.is(":radio") === "radio")
            value = $elem.prop("checked") ? "true" : "false";
        else
            value = $elem.val();

        return value;
    }

    // Gets the MVC-generated prefix for a field by returning the given string up to and including the last underscore character
    function getModelIDPrefix(fieldID) {
        return fieldID.substr(0, fieldID.lastIndexOf("_") + 1);
    }
}(jQuery));